import type { Service } from '~publish/gql/graphql'

/**
 * This file is auto-generated by the sync-templates script.
 * It is not intended to be edited directly.
 * Any changes made to this file will be lost.
 */

/**
 * Author of the template.
 */
export type Author = {
  email: string
  name: string
}

/**
 * Intended outcome from usage of the template.
 */
export type Goal =
  | 'Engagement'
  | 'Connection'
  | 'Reflection'
  | 'Expertise'
  | 'Promotion'
  | 'Education'
  | 'Celebration'

/**
 * Structure/format of the template.
 */
export type Structure = 'Single Text' | 'Threaded'

/**
 * Types of users that can use the template.
 */
export type UserType = 'Business' | 'Individual'

/**
 * Generic type of the template.
 */
export type Type =
  | 'Tip'
  | 'Case Study'
  | 'Story'
  | 'How-to'
  | 'Question'
  | 'Behind the scenes'
  | 'Opinion'
  | 'List'

/**
 * Tags for the template.
 */
export type Tag = 'New' | 'Featured'

/**
 * Color value for the template background in RGB format.
 */
export type Color = string

/**
 * Template - used to create inspiration for users to create content.
 */
export type Template = {
  id: string
  body: string
  emoji: string
  services: Service[]
  userTypes: UserType[]
  structure: Structure
  author: Author
  goal: Goal
  description: string
  type: Type
  title: string
  tags: Tag[]
  createdAt: string
  color: Color
  // TODO: creator-camp-cleanup
  creatorCampDate: string | null
}

// Export the actual possible values for each type
export const USER_TYPES: UserType[] = ['Business', 'Individual']
export const STRUCTURES: Structure[] = ['Single Text', 'Threaded']
export const GOALS: Goal[] = [
  'Engagement',
  'Connection',
  'Reflection',
  'Expertise',
  'Promotion',
  'Education',
  'Celebration',
]
export const TYPES: Type[] = [
  'Tip',
  'Case Study',
  'Story',
  'How-to',
  'Question',
  'Opinion',
  'List',
  'Behind the scenes',
]
export const TAGS: Tag[] = ['New', 'Featured']
export const SERVICES = [
  'X',
  'LinkedIn',
  'Threads',
  'Mastodon',
  'Bluesky',
  'Instagram',
  'TikTok',
  'YouTube',
  'Facebook',
  'Pinterest',
  'Google Business',
  'Start Page',
]
